import PerformanceArts from "../components/pages/PerformanceArts";

export default PerformanceArts;
